import React from "react";
const ServiceCitySelect = (props) => {
  const cityList = props.cityList === null ? [] : props.cityList;
  // const SelectedCity = props.state.withinCitySelectCity;
  // if (props.parentState.serviceCity) {
  // cityList.map((cityObj, index) => {
  //   return (
  // <option key={index} value={cityObj.city}>
  //   {cityObj.city}
  // </option>
  //   );
  const JSX = (
    <select
      name={props.name}
      className={props.className}
      id={props.id}
      ref={props.innerRef}
      defaultValue={props.defaultValue}
      onChange={props.onChange}
    >
      <option hidden value="">
        Select City
      </option>
      {cityList.map((cityObj) => {
        return (
          <option
            key={"cityListid91sjaxau3-" + cityObj.id}
            value={cityObj.city}
          >
            {cityObj.city}
          </option>
        );
      })}
    </select>
  );
  return JSX;
};

export default ServiceCitySelect;
